<!--APP-SIDEBAR-->
<div class="sticky">
  <div class="app-sidebar__overlay" data-bs-toggle="sidebar" (click)="sidebarClose()"></div>
  <div class="app-sidebar">
    <div class="side-header">
      <a class="header-brand1" routerLink="/">
        <app-logo class="bigLogo"></app-logo>
      </a>
      <a
        aria-label="Hide Sidebar"
        class="app-sidebar__toggle"
        data-bs-toggle="sidebar"
        (click)="toggleSidebar($event)"
        aria-label="Open folder"
      >
        <i class="humberger-menu" aria-hidden="true"></i>
      </a>
      <!-- LOGO -->
    </div>
    <div ngbDropdown class="dropdown">
      <div class="main-sidemenu customScroll">
        <ul class="side-menu open flex-nowrap">
          @for (menuItem of menuItems; track $index) {
            <ng-container>
              <li class="side-item">
                <!-- Parent Link Without Submenu -->
                <ng-container *ngIf="!menuItem.Menusub">
                  <a
                    (click)="hideToggle()"
                    class="side-menu__item"
                    [routerLink]="menuItem.path"
                    routerLinkActive="active"
                    [ngbTooltip]="menuItem.title"
                    [disableTooltip]="!isToggleClick"
                    container="body"
                    tooltipClass="tooltipNew"
                    placement="auto"
                    aria-label="Open folder"
                  >
                    <span class="side-menu__icon">
                      <i [ngClass]="menuItem.iconClass"></i>
                    </span>
                    <span class="side-menu__label">{{ menuItem.title }}</span>
                  </a>
                </ng-container>
              </li>
            </ng-container>
          }
        </ul>
      </div>
    </div>
  </div>

  <svg style="display: none">
    <symbol id="dataSpaceIcon" width="25" height="25" viewBox="0 0 30 30">
      <g id="ic_sales_dataspace" transform="translate(-13 -16)">
        <g id="ic_data_insights" transform="translate(-43.273 -223.533)">
          <rect
            id="Rectangle_21493"
            data-name="Rectangle 21493"
            width="30"
            height="30"
            transform="translate(56.273 239.533)"
            fill="none"
          />
          <g id="noun-data-2994678" transform="translate(57.729 223.946)">
            <path
              id="Path_146944"
              data-name="Path 146944"
              d="M29.151,29.1a1.555,1.555,0,0,0-.351.042L25.43,23.3a2.048,2.048,0,0,0,.694-1.539,2.066,2.066,0,0,0-4.089-.418H15.3a1.5,1.5,0,0,0-2.935.418,1.468,1.468,0,0,0,.418,1.029L9.418,28.63a2.064,2.064,0,1,0-.652,4.022,1.827,1.827,0,0,0,.644-.109l3.37,5.837a1.49,1.49,0,0,0,1.079,2.525A1.5,1.5,0,0,0,15.3,39.827h6.731a2.066,2.066,0,0,0,4.089-.418,2.048,2.048,0,0,0-.694-1.539l3.37-5.837a1.678,1.678,0,0,0,.351.042,1.5,1.5,0,0,0,1.5-1.5A1.479,1.479,0,0,0,29.151,29.1ZM13.515,23.22a1.678,1.678,0,0,0,.351.042A1.5,1.5,0,0,0,15.3,22.183h6.731a2.051,2.051,0,0,0,.686,1.154L20.2,27.97a2.793,2.793,0,0,0-3.713,2.2H10.8a2.067,2.067,0,0,0-.652-1.12ZM22.044,39H15.313a1.5,1.5,0,0,0-1.438-1.079,1.555,1.555,0,0,0-.351.042l-3.37-5.828a2.067,2.067,0,0,0,.652-1.12H16.5a2.792,2.792,0,0,0,2.759,2.366,2.847,2.847,0,0,0,.928-.159L22.679,37.9A1.949,1.949,0,0,0,22.044,39Zm2.015-1.647a2.2,2.2,0,0,0-.669.109L20.915,32.82a2.78,2.78,0,0,0,.017-4.448l2.525-4.632a2.059,2.059,0,0,0,.6.092,1.827,1.827,0,0,0,.644-.109l3.37,5.837a1.483,1.483,0,0,0-.418,1.028,1.468,1.468,0,0,0,.418,1.029L24.7,37.452A2.3,2.3,0,0,0,24.059,37.352Z"
              transform="translate(-5.126)"
            />
          </g>
        </g>
      </g>
    </symbol>
  </svg>
</div>
